import { Alert } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

import { cn } from '@/lib/utils';

interface LoadErrorProps {
    /** What failed to load, e.g. "the snapshot list"; shown as "Couldn't load <what>." */
    what: string;
    /** Refetches only the query behind this part of the page. */
    onRetry: () => void;
    isRetrying?: boolean;
    className?: string;
    'data-testid'?: string;
}

/** Inline failed-load notice that names what failed and retries just that query. */
export function LoadError({
    what,
    onRetry,
    isRetrying = false,
    className,
    'data-testid': dataTestId,
}: LoadErrorProps) {
    return (
        <Alert
            variant="destructive"
            className={cn(
                'flex items-center justify-between gap-4 px-4 py-3 text-sm',
                className,
            )}
            data-testid={dataTestId}
        >
            <p>{`Couldn't load ${what}.`}</p>
            <Button
                type="button"
                size="sm"
                variant="outline"
                onClick={onRetry}
                disabled={isRetrying}
                data-testid="LoadError__retry"
            >
                {isRetrying ? 'Retrying…' : 'Retry'}
            </Button>
        </Alert>
    );
}
